export default {
    // 体型类别定义
    // BMI<18.5
    SOMATOTYPE_Y : 'Y',
    // <18.5BMI<=23
    SOMATOTYPE_A : 'A',
    // <23BMI<=26
    SOMATOTYPE_B : 'B',
    // <26BMI<=29
    SOMATOTYPE_C : 'C',

    SOMATOTYPE_BD : 'BD',

    SOMATOTYPE_CD : 'CD',
    // BMI>29
    SOMATOTYPE_D : 'D',

    SOMATOTYPE_E : 'E',
    //
    SOMATOTYPE_T : 'T',
    // 穿衣偏好
    // 标准（合身）
    PREFERENCE_NORMAL: '1',
    // 收身（紧身）
    PREFERENCE_FITTED: '2',
    // 宽松
    PREFERENCE_LOOSE: '3',
    // 合体
    PREFERENCE_STANDARD: '4',
    // 净体尺寸参数定义 start
    // 后中长，颈至臀 back middle length
    N_HZC_BML: 'N_001',
    // 后腰节长 back waist length 废弃
    N_HYJC_BWL: 'N_002',
    // 总肩宽 shoulder width
    N_ZJK_SW: 'N_003',
    // 长袖长 long sleeve length
    N_CXC_LSL: 'N_004',
    // 短袖长 short sleeve length
    N_DXC_SSL: 'N_005',
    // 上臂围 upper arm length
    N_SBW_UAL: 'N_006',
    // 手腕围 twist length
    N_SWW_TL: 'N_007',
    // 背宽 back width
    N_BK_BW: 'N_008',
    // 胸宽，前宽 chest width
    N_XK_CW: 'N_009',
    // 前衣长 front cloth length 废弃
    N_QYC_FCL: 'N_010',
    // 胸高点 chest high point
    N_XGD_CHP: 'N_011',
    // 领围，颈围 collar length
    N_LW_CL: 'N_012',
    // 胸围 chest length
    N_XW_CL: 'N_013',
    // 中腰长，中腰 middle waist length
    N_ZYW_MWL: 'N_014',
    // 裤腰长，K腰长 trouser waist length
    N_KYW_TWL: 'N_015',
    // 臀围 hip length
    N_TW_HL: 'N_016',
    // 大腿围，K大腿围 lap length
    N_DTW_LL: 'N_017',
    // 通裆长，K全裆 crotch length
    N_TDC_CL: 'N_018',
    // 膝围 knee length 废弃
    N_XW_KL: 'N_019',
    // 小腿肚围，K小腿围 calf length
    N_XTDW_CL: 'N_020',
    // 裤长，K腿长 trouser length
    N_KC_TL: 'N_021',
    // 肚围 belly height
    N_DW_BL: 'N_022',
    // 臂宽 arm width
    N_BK_AW: 'N_024',
    // 颈宽 neck width
    N_JK_NW: 'N_025',
    // 臂根围 arm length
    N_BGW_AL: 'N_026',
    // K前中下 front
    N_QZX_F: 'N_027',
    // K立裆 crotch
    N_LD_C: 'N_028',
    // 胸距 chest distance
    N_XJ_CD: 'N_029',
    // 凸肚高 belly height
    N_TDG_BH: 'N_023',
    // K臀围 hip length
    N_KTW_HL: 'N-099',
    // 净体尺寸参数定义 end


    // 成衣尺寸 start
    // 前衣长 front cloth length
    C_QYC_FCL: '001',
    // 后衣长 back cloth length
    C_HYC_BCL: '002',
    // 胸围 chest length
    C_XW_CL: '003',
    // 中腰 middle waist
    C_ZY_MW: '004',
    // 肚围 belly length
    C_DW_BL: '005',
    // 下摆 Hem Circumference
    C_XB_HC: '006',
    // 肩宽 shoulder width
    C_JK_SW: '007',
    // 胸宽 chest width
    C_XK_CW: '008',
    // 袖长 sleeve length
    C_XC_SL: '009',
    // 短袖长 short sleeve length
    C_DXC_SSL: '010',
    // 袖肥 bicep
    C_XF_B: '011',
    // 袖口 sleeve opening
    C_XK_SO: '012',
    // 短袖袖口 short sleeve opening
    C_DXXK_SSO: '013',
    // 领围 collar length
    C_LW_CL: '014',
    // 背宽 back width
    C_BK_BW: '015',
    // 裤长 trouser length
    C_KC_TL: '016',
    // 腰围 waist length
    C_YW_WL: '017',
    // 臀围 hip length
    C_TW_HL: '018',
    // 总浪长 front&back rise
    C_ZLC_FBR: '019',
    // 横裆 Thigh
    C_HD_T: '020',
    // 膝围（横裆下32） Knee circumference
    C_XW_KL: '021',
    // 小腿围 Calf
    C_XTW_C: '022',
    // 脚口 feet
    C_JK_F: '023',
    // 胸高 chest height
    C_XG_CH: '024',
    // BP点 B length
    C_BPD_B: '025',
    // 身高 height 废弃
    C_SG_H: '026',
    // 裙长 skirt_length
    C_QC_SL: '028',
    // 内长 inner length
    C_NC_IL: '029',
    // 前长调整 F
    C_QCTZ_F: '30',
    // K裤长 trouser length
    C_KKC_TL: '032',
    // 凸肚高 belly height
    C_TDG_BH: '033',
    // K腰围 waist length
    C_KYW_WL: '034',
    // K大腿围 lap length
    C_KDTW_LL: '038',
    // K脚口 feet
    C_KJK_F: '039',
    // K全裆 full crotch
    C_KQD_FC: '041',
    // K袖壮 arm
    C_KXZ_A: '049',
    // K臀围 hip length
    C_KTW_AL: '050',
    // 成衣尺寸 end


    // 体态特征
    // 版型
    B_BX_V : '2',
    // 身型
    B_SX_S : '1',
    // 肩斜调整，肩型
    B_JXTZ_ST : '3',
    // 挺胸，胸型
    B_TX_C : '4',
    // 驼背，背型
    B_TB_B : '5',
    // 凸肚，腹型
    B_TD_B : '6',
    // 凸臀体，臀型
    B_TTT_HT : '7',
    // 坠臀体，臀围
    B_ZTT_H : '8',
}
